import { createContext, use } from 'react';
import { graphql, useFragment } from 'react-relay';
import type { listPaginationQueryFragment$key } from './__generated__/listPaginationQueryFragment.graphql';
import type { listPaginationQuerySortFragment$key } from './__generated__/listPaginationQuerySortFragment.graphql';

export const ListPaginationQueryCtx = createContext<
    listPaginationQueryFragment$key | null | undefined
>(null);

const listPaginationQueryFragment = graphql`
    fragment listPaginationQueryFragment on PageInfo {
        hasContent
        hasNext
        hasPrevious
        isFirst
        isLast
        pageNum: number # alias wie bisher
        pageSize: size # alias wie bisher
        sort {
            ...listPaginationQuerySortFragment
        }
        totalElements
        totalPages
    }
`;

export const useListPaginationQueryFragmentCtx = () =>
    useFragment(listPaginationQueryFragment, use(ListPaginationQueryCtx));

export const useListPaginationQueryFragment = (fragmentRef?: listPaginationQueryFragment$key) =>
    useFragment(listPaginationQueryFragment, fragmentRef);

export const ListPaginationQuerySortCtx = createContext<
    listPaginationQuerySortFragment$key | null | undefined
>(null);

const listPaginationQuerySortFragment = graphql`
    fragment listPaginationQuerySortFragment on Sort {
        isSorted
        isUnsorted
        orders: toList {
            direction
            isAscending
            isDescending
            property
        }
    }
`;

export const useListPaginationQuerySortFragmentCtx = () =>
    useFragment(listPaginationQuerySortFragment, use(ListPaginationQuerySortCtx));

export const useListPaginationQuerySortFragment = (
    fragmentRef?: listPaginationQuerySortFragment$key
) => useFragment(listPaginationQuerySortFragment, fragmentRef);

export const useListPaginationQuerySortFragmentRef = (
    fragmentRef?: listPaginationQueryFragment$key
) => useListPaginationQuerySortFragment(useListPaginationQueryFragment(fragmentRef)?.sort);
